var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-filter d-flex justify-center"},[_c('div',{staticClass:"qickfilter__btns d-flex"},[_c('btn-group',{attrs:{"btns":_vm.items,"group":""},on:{"update:btn":function($event){_vm.index=$event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }